import 'react-tagsinput/react-tagsinput.css';
import PropTypes from 'prop-types';
import React from 'react';
import TagsInput from 'react-tagsinput';

import { Tooltip } from '@commons/utils/styledLibraryComponents';

import { Container, LabelContainer, TagsInputContainer } from './styledComponents';

const SEMICOLON_KEY_CODES = [186, 59]; // standard + Firefox variant
const ADD_KEYS = [...SEMICOLON_KEY_CODES, 13]; // semicolons + Enter

const splitBySemicolon = (value) => {
  if (!value) {
    return [];
  }

  return value
    .split(';')
    .map((tag) => tag.trim())
    .filter((tag) => tag.length > 0);
};

const InputTagChip = (props) => {
  const { value, onChange, label, tooltipText, placeholder, isDisabled } = props;

  const tags = splitBySemicolon(value);

  const handleChange = (nextTags) => {
    onChange(nextTags.join(';'));
  };

  const handlePasteSplit = (pastedValue) => splitBySemicolon(pastedValue);

  return (
    <Container>
      {label && (
        <LabelContainer>
          {label}
          {tooltipText && <Tooltip text={tooltipText} />}
        </LabelContainer>
      )}
      <TagsInputContainer isDisabled={isDisabled}>
        <TagsInput
          addKeys={ADD_KEYS}
          disabled={isDisabled}
          inputProps={{
            className: 'react-tagsinput-custom',
            placeholder: tags.length === 0 ? placeholder : '',
          }}
          pasteSplit={handlePasteSplit}
          value={tags}
          addOnPaste
          onlyUnique
          onChange={handleChange}
        />
      </TagsInputContainer>
    </Container>
  );
};

InputTagChip.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  tooltipText: PropTypes.string,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
};

InputTagChip.defaultProps = {
  value: '',
  label: '',
  tooltipText: null,
  placeholder: '',
  isDisabled: false,
};

export default InputTagChip;
